import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4899 17.354C11.3989 17.6109 12.3583 17.6296 13.2766 17.4081L9.11403 21.583C6.66634 20.8391 4.59716 19.1782 3.33483 16.9443C2.0725 14.7105 1.71368 12.0746 2.33264 9.5823C2.95088 7.08982 4.50032 4.93189 6.65977 3.55586C8.81921 2.17984 11.423 1.69127 13.9314 2.19143C13.9314 2.19143 10.5576 5.53743 8.72024 7.37626C8.14106 7.92976 7.63542 8.55602 7.21584 9.23953C6.57666 10.288 6.31422 11.5248 6.47221 12.744C6.6302 13.9631 7.19908 15.0912 8.08419 15.9404C8.75267 16.6103 9.58094 17.097 10.4899 17.354Z"
      fill="#11181C"
    />
    <path
      d="M10.7139 6.59581C11.632 6.37395 12.5914 6.3924 13.5004 6.64937C14.4094 6.90634 15.2376 7.39325 15.9057 8.06353C17.7264 9.89292 18.0821 12.6078 16.7674 14.7544C16.3471 15.4384 15.8415 16.0657 15.263 16.621C13.4251 18.4571 10.0513 21.8053 10.0513 21.8053C12.5619 22.3104 15.1698 21.8245 17.333 20.4485C19.4962 19.0726 21.0485 16.9123 21.6672 14.4167C22.2867 11.9212 21.9259 9.28192 20.6596 7.04655C19.3933 4.81118 17.3187 3.15135 14.8664 2.4115L10.7139 6.59581Z"
      fill="#11181C"
    />
  </svg>
)
